import React, { useEffect } from 'react';
import FormContainer from '../layout/form-container';

const RedirectWisemapping = (): React.ReactElement => {
  useEffect(() => {
		window.onerror = () => {
			return true; 
		  };

		  window.location.href = 'https://api.stg.map.thinkmapping.com/api/mindmap/redirect-to-mindmap-list';
  }, []);

  return (
    <div>
      <FormContainer>
        <h1>Redirecting to Dashboard ThinkMapping...</h1>
        <img src="thinkmapping-logo.png" alt="ThinkMapping Logo" />
        <img src="loader.gif" alt="Loading" />
      </FormContainer>
    </div>
  );
};

export default RedirectWisemapping;